import "firebase/compat/storage";
import { call, takeLatest, put, all, take, race, cancelled, takeEvery } from "redux-saga/effects";
import { callApi } from "../../util/superAgentUtil";
import actions from "../actionType";
import { notification } from "../../util/notification";
import formatMsg from "../../util/formatMsg";
import Helper from "../../util/helper";
import dbRef from "../../firebase-api/dbRef";
import fbRef from "../../libs/fbRef";
import { EventChannel } from "redux-saga";

function* createActivity(actionObj: Record<string, any>) {
    try {
        const { firebase, payload, fileList } = actionObj.payload;
        let storagePath = firebase.sbp + "/media/images/";

        let endpoint = `bookingoApi/activityPost`

        if (payload.customActivityObject?.image) {
            let mediaProfilesUrl = yield call(
                Helper.getAttachedMediaPath,
                storagePath,
                { file: "", fileList: [payload.customActivityObject?.image] },
                firebase
            );
            payload.customActivityObject.icon = mediaProfilesUrl[0]?.path
            delete payload.customActivityObject.image;
        }

        let response = yield call(callApi, firebase, "post", endpoint, payload);

        if (response.status == 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    isLoading: false,
                    operationType: 'POST_CREATED',
                }
            });
            notification("success", formatMsg("postActivitySuccess" + (fileList?.length ? ".mediaUpload" : "")));
            if (fileList?.length) {
                const activityCreated = response.body.data.activityPost;
                yield call(uploadActivityMedia, { payload: { fileList, firebase, activityPostId: activityCreated.id, actionType: "create" } })
                notification("success", formatMsg("success.activityMediaUpload"));
            }
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    }
    catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to post activity", err);
    }
}

function* uploadActivityMedia(payload) {
    try {
        let { firebase, fileList, activityPostId, actionType } = payload.payload;
        let storagePath = firebase.sbp + "/media/images/";

        if (fileList?.length) {
            let attachmentWithoutUrl = fileList.filter(item => !item.path);
            let attachmentWithUrl = fileList.filter(item => item.path);
            let uploadedFiles = [];

            for (let i = 0; i < attachmentWithoutUrl.length; i += 4) {
                let batch = attachmentWithoutUrl.slice(i, i + 4);

                let uploadTasks = batch.map(file =>
                    call(function* () {
                        try {
                            let mediaProfilesUrl = yield call(
                                Helper.getAttachedMediaPath,
                                storagePath,
                                { file: "", fileList: [file] },
                                firebase
                            );
                            if (mediaProfilesUrl.length) {
                                let endpoint = `bookingoApi/activityPost/media/${activityPostId}`
                                yield call(callApi, firebase, "post", endpoint, { mediaProfiles: mediaProfilesUrl, actionType });
                                return mediaProfilesUrl[0];
                            }
                        } catch (error) {
                            console.error("Failed to upload media:", file, error);
                        }
                        return null;
                    })
                );

                let batchResults = yield all(uploadTasks);
                uploadedFiles.push(...batchResults.filter(file => file !== null));
            }
            fileList = uploadedFiles.concat(attachmentWithUrl);
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to uploadActivityMedia", err);
    }
}

function* deleteActivityPost(request) {
    try {
        const { firebase, id } = request.payload;
        let endpoint = "bookingoApi/activityPost/" + id;
        let response = yield call(callApi, firebase, "delete", endpoint, {});
        if (response.status == 200) {
            notification("success", formatMsg("deleteActivitySuccess"));
            yield put({ type: actions.ACTIVITY_SAGA_SUCCESS, payload: { isLoading: false, operationType: "ACTIVITY_DELETED" } });
        }
        else {
            notification("error", response?.body?.data?.message || formatMsg("error.occured"))
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to delete post ", err);
    }
}

function* activeInactiveActivity(request) {
    try {
        const { firebase, activityId, status } = request.payload;
        let endpoint = `bookingoApi/activityPost/${activityId}/activeInactive`
        let response = yield call(callApi, firebase, "post", endpoint, { status: status });
        if (response.status == 200) {
            notification("success", formatMsg("postStatusUpdated"))
            yield put({ type: actions.ACTIVITY_SAGA_SUCCESS, payload: { operationType: "STATUS_UPDATED", isLoading: false } });
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED, isLoading: false });
            notification("error", response?.body?.message || formatMsg("error.occured"))
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED, isLoading: false });
        console.log("failed to update package status ", err);
    }
}

function* getActivityForEdit(request) {
    try {
        let { firebase, id, comments } = request.payload;
        let endpoint = "bookingoApi/activityPost/" + id + (comments ? "?comments=true" : "");

        let response = yield call(callApi, firebase, "get", endpoint, {}, false, false, comments);
        if (response.status == 200) {
            yield put({ type: actions.ACTIVITY_SAGA_SUCCESS, payload: { isLoading: false, editActivity: response.body.data, operationType: "EDIT_ACTIVITY_FETCHED" } });
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to getActivityForEdit", err);
    }
}

function* updateActivity(request) {
    try {
        const { firebase, reqObj, fileList } = request.payload;
        let endpoint = `bookingoApi/activityPost/${reqObj.id}`;
        let response = yield call(callApi, firebase, "post", endpoint, reqObj);
        if (response.status == 200) {
            notification("success", formatMsg("updateActivitySuccess" + (fileList?.length ? ".mediaUpload" : "")));
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    operationType: "ACTIVITY_UPDATED",
                    isLoading: false
                }
            });
            if (fileList?.length) {
                const activityEdited = response.body.data.activityPost;
                yield call(uploadActivityMedia, { payload: { fileList, firebase, activityPostId: activityEdited.id, actionType: "update" } })
                notification("success", formatMsg("success.activityMediaUpload"));
            }
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to update activity ", err);
    }
}

// The feeds read posts through the API. Their channels are /lastUpdate entries the backend
// bumps on every write to a post (activityPost), to what a timeline holds
// (activityTimeline), to one post (activityPostById/<id>) and to the activity types.
function* getAllAdminActivities(request) {
    try {
        let { firebase, startDate, endDate } = request.payload;
        const adminActivityChan = yield call(dbRef.getLastUpdateChannel, firebase, fbRef.lastUpdateActivityPost);
        while (true) {
            yield take(adminActivityChan);
            const endpoint = `bookingoApi/activityPost/feed?startDate=${startDate}&endDate=${endDate}&authorId=${encodeURIComponent(firebase.user?.id || "")}`;
            const response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
            let activityList = response?.body?.data || [];
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    isLoading: false,
                    activityList: activityList,
                    adminActivityChannel: adminActivityChan,
                    operationType: "ACTIVITY_FETCHED"
                }
            });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed get all activities  ", err);
    } finally {
        console.log("admin activity channel closed")
    }
}

export function* getAllListingActivities(request) {
    try {
        const { firebase, userIds, startDate, endDate } = request.payload;
        yield put({
            type: actions.ACTIVITY_SAGA_SUCCESS,
            payload: {
                activityList: [],
            }
        });

        // One channel now serves every timeline; userActivityChans stays for the screens
        // that close it on the way out.
        const userActivityChans: any[] = [];
        const publicTimelineChan: any = yield call(dbRef.getLastUpdateChannel, firebase, fbRef.lastUpdateActivityTimeline);
        const endpoint = `bookingoApi/activityPost/timelineIds?startDate=${startDate}&endDate=${endDate}&userIds=${encodeURIComponent(userIds.filter(Boolean).join(","))}`;

        let operationType = "ACTIVITY_INITIAL";
        while (true) {
            yield take(publicTimelineChan);
            const response = yield call(callApi, firebase, "get", endpoint, {}, false, false, true);
            const activityListIds: string[] = response?.body?.data || [];

            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    isLoading: false,
                    activityListIds,
                    userActivityChans,
                    publicTimelineChan,
                    operationType
                }
            });
            operationType = "ACTIVITY_FETCHED";
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.error("Failed to get all activities:", err);
    }
}

function* watchSingleActivity(request) {
    const { firebase, activityId } = request.payload;
    const chan = yield call(dbRef.getLastUpdateChannel, firebase, `${fbRef.lastUpdateActivityPostById}/${activityId}`);
    try {
        while (true) {
            yield take(chan);
            const response = yield call(callApi, firebase, "get", `bookingoApi/activityPost/${activityId}?comments=true`, {}, false, false, true);
            const postVal = response?.body?.data || null;
            // A deleted post comes back empty and is never coming back; one that is still
            // uploading or unpublished is hidden but may show up again.
            const post = postVal && postVal.status === "SUCCESS" && !postVal.inactive ? postVal : null;
            yield put({
                type: actions.ACTIVITY_BY_ID_UPDATE,
                payload: { activityId, post, chan },
            });
            if (!postVal) {
                chan.close();
                return;
            }
        }
    } catch (err) {
        console.log("failed to watch activity", activityId, err);
    } finally {
        console.log("unsub ind activity")
    }
}

function* likeActivity(actionObj: Record<string, any>) {
    try {

        const { firebase, reqObj } = actionObj.payload;

        let endpoint = "bookingoApi/activityPost/likeActivity"
        let response = yield call(callApi, firebase, "post", endpoint, reqObj);

        if (response.status == 200) {
            const activityLiked = response.body.data;

            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    // isLoading: false,
                    liked: activityLiked.liked,
                    operationType: 'ACTIVITY_LIKED',
                }
            });
            // notification("success", activityLiked.message);
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    }
    catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to like activity", err);
    }
}

function* likeActivityComment(actionObj: Record<string, any>) {
    try {
        const { firebase, reqObj, type } = actionObj.payload;
        let endpoint = type == "reply" ? "bookingoApi/activityPost/comment/reply/like" : "bookingoApi/activityPost/comment/like"
        let response = yield call(callApi, firebase, "post", endpoint, reqObj);

        if (response.status == 200) {
            const activityLiked = response.body.data;

            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    commentLoading: false,
                    operationType: 'ACTIVITY_COMMENT_LIKED',
                    refetchComments: true
                }
            });
            // notification("success", activityLiked.message);
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    }
    catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to like activity", err);
    }
}

function* postActivityComment(actionObj: Record<string, any>) {
    try {
        let { firebase, payload } = actionObj.payload;
        payload = { ...payload, userId: firebase.user.id, userType: firebase.user.userType, userName: firebase.user.name, userProfilePicture: firebase.user.profilePhoto || firebase.user.profileImageUrl || firebase.user.authorProfileUrl || null }
        let endpoint = `bookingoApi/activityPost/comment`
        let response = yield call(callApi, firebase, "post", endpoint, payload);

        if (response.status == 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    commentLoading: false,
                    operationType: 'COMMENT_POSTED',
                    refetchComments: true
                }
            });
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    }
    catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to post activity comment", err);
    }
}

function* postCommentReply(actionObj: Record<string, any>) {
    try {
        let { firebase, payload } = actionObj.payload;
        payload = { ...payload, userId: firebase.user.id, userType: firebase.user.userType, userName: firebase.user.name, userProfilePicture: firebase.user.profilePhoto || firebase.user.profileImageUrl || firebase.user.authorProfileUrl || null }
        let endpoint = `bookingoApi/activityPost/comment/reply`
        let response = yield call(callApi, firebase, "post", endpoint, payload);

        if (response.status == 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    commentLoading: false,
                    operationType: 'COMMENT_POSTED',
                    refetchComments: true
                }
            });
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    }
    catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to post activity comment", err);
    }
}

function* updateActivityComment(actionObj: Record<string, any>) {
    try {
        let { firebase, payload } = actionObj.payload;

        const endpoint = `bookingoApi/activityPost/comment`;
        const response = yield call(callApi, firebase, 'put', endpoint, payload);

        if (response.status === 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    commentLoading: false,
                    operationType: 'COMMENT_UPDATED',
                    refetchComments: true
                }
            });
        } else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg('oopsSomthingWentWrong'));
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log('failed to update activity comment', err);
    }
}

function* deleteActivityComment(actionObj: Record<string, any>) {
    try {
        let { firebase, payload } = actionObj.payload;
        const endpoint = `bookingoApi/activityPost/comment`;
        const response = yield call(callApi, firebase, 'delete', endpoint, payload);

        if (response.status === 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    commentLoading: false,
                    operationType: 'COMMENT_DELETED',
                    refetchComments: true
                }
            });
        } else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg('oopsSomthingWentWrong'));
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log('failed to delete activity comment', err);
    }
}

function* updateCommentReply(actionObj: Record<string, any>) {
    try {
        let { firebase, payload } = actionObj.payload;

        const endpoint = `bookingoApi/activityPost/comment/reply`;
        const response = yield call(callApi, firebase, 'put', endpoint, payload);

        if (response.status === 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    commentLoading: false,
                    operationType: 'REPLY_UPDATED',
                    refetchComments: true
                }
            });
        } else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg('oopsSomthingWentWrong'));
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log('failed to update reply', err);
    }
}

function* deleteCommentReply(actionObj: Record<string, any>) {
    try {
        let { firebase, payload } = actionObj.payload;

        const endpoint = `bookingoApi/activityPost/comment/reply`;
        const response = yield call(callApi, firebase, 'delete', endpoint, payload);

        if (response.status === 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    commentLoading: false,
                    operationType: 'REPLY_DELETED',
                    refetchComments: true
                }
            });
        } else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg('oopsSomthingWentWrong'));
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log('failed to delete reply', err);
    }
}

function* getActivityComment(actionObj: Record<string, any>) {
    try {
        let { firebase, payload } = actionObj.payload;
        let endpoint = `bookingoApi/activityPost/comment/${payload.activityPostId}`
        let response = yield call(callApi, firebase, "get", endpoint, {});

        if (response.status == 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    commentLoading: false,
                    operationType: 'COMMENT_FETCHED',
                    comments: response.body.data
                }
            });
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    }
    catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to post activity comment", err);
    }
}

function* getGuestActivities(actionObj: Record<string, any>) {
    try {
        let { firebase, startDate, endDate } = actionObj.payload;
        let endpoint = `bookingoApi/activityPost/activitiesForGuest?startDate=${startDate}&endDate=${endDate}`;
        let response = yield call(callApi, firebase, "get", endpoint, {}, true, null, true);

        if (response.status == 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    isLoading: false,
                    activityList: response.body.data,
                    operationType: 'ACTIVITY_FETCHED'
                }
            });
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    }
    catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to getGuestActivities", err);
    }
}

function* getPackageAndCentersOfAccounts(actionObj: Record<string, any>) {
    try {
        let { firebase, accountId } = actionObj.payload;
        let endpoint = `bookingoApi/${Helper.isAccount(firebase) ? "account" : "teacher"}/packagesAndCenters/${accountId}`;
        let response = yield call(callApi, firebase, "get", endpoint, {});

        if (response.status == 200) {
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    isLoading: false,
                    packageAndCenters: response.body.data,
                }
            });
        }
        else {
            yield put({ type: actions.ACTIVITY_SAGA_FAILED });
            notification('error', formatMsg(`oopsSomthingWentWrong`));
        }
    }
    catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to getPackageAndCentersOfAccounts", err);
    }
}

function* getActivityType(actionObj: Record<string, any>) {
    try {
        const { firebase } = actionObj.payload;
        const activityTypeChan = yield call(dbRef.getLastUpdateChannel, firebase, fbRef.lastUpdateActivityType);
        while (true) {
            yield take(activityTypeChan);
            const response = yield call(callApi, firebase, "get", "bookingoApi/activityPost/activityTypes", {});
            let activityType = response?.body?.data || [];
            yield put({
                type: actions.ACTIVITY_SAGA_SUCCESS,
                payload: {
                    activityType: activityType,
                    activityTypeChannel: activityTypeChan,
                    operationType: "ACTIVITY_TYPE_FETCHED"
                }
            });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ACTIVITY_SAGA_FAILED });
        console.log("failed to get activity type ", err);
    } finally {
        console.log("activity type channel closed")
    }
}

export default function* rootSaga() {
    yield takeLatest(actions.CREATE_ACTIVITY, createActivity);
    yield takeLatest(actions.UPLOAD_ACTIVITY_MEDIA, uploadActivityMedia);
    yield takeLatest(actions.DELETE_ACTIVITY_POST, deleteActivityPost);
    yield takeLatest(actions.ACTIVE_INACTIVE_ACTIVITY, activeInactiveActivity);
    yield takeLatest(actions.UPDATE_ACTIVITY, updateActivity);
    yield takeLatest(actions.GET_ACTIVITY_FOR_EDIT, getActivityForEdit);
    yield takeLatest(actions.GET_ALL_ADMIN_ACTIVITIES, getAllAdminActivities);
    yield takeLatest(actions.GET_ALL_LISTING_ACTIVITIES, getAllListingActivities);
    yield takeLatest(actions.LIKE_ACTIVITY, likeActivity);
    yield takeLatest(actions.LIKE_ACTIVITY_COMMENT, likeActivityComment);
    yield takeLatest(actions.POST_ACTIVITY_COMMENT, postActivityComment);
    yield takeLatest(actions.POST_ACTIVITY_COMMENT_REPLY, postCommentReply);
    yield takeLatest(actions.GET_ACTIVITY_COMMENT, getActivityComment);
    yield takeLatest(actions.GET_GUEST_ACTIVITIES, getGuestActivities);
    yield takeLatest(actions.GET_PACKAGE_AND_CENTERS_OF_ACCOUNTS, getPackageAndCentersOfAccounts);
    yield takeLatest(actions.UPDATE_ACTIVITY_COMMENT, updateActivityComment);
    yield takeLatest(actions.DELETE_ACTIVITY_COMMENT, deleteActivityComment);
    yield takeLatest(actions.UPDATE_ACTIVITY_REPLY, updateCommentReply);
    yield takeLatest(actions.DELETE_ACTIVITY_REPLY, deleteCommentReply);
    yield takeLatest(actions.GET_ACTIVITY_TYPE, getActivityType);
    yield takeEvery(actions.WATCH_SINGLE_ACTIVITY, watchSingleActivity);
}